import axios from "./axios";

// let api = {
//     reqCategory:{
//         list: param => {
//             return axios.post('/category',param)
//         }
//     }
// }

// //类型菜单
export const reqCategory = ()=>axios({url:'/category',method:'post'});
//
export const reqSlider = ()=>axios({url:'/slider',method:'post'});

export const reqRecommend = (params)=>axios({url:'/recommend',method:'post',data:params})

export const reqCatalogue = ()=>axios({url:"/catalog",method:'post'})

export const reqDatail = (params)=>axios({url:"/datail",method:'post',data:params})

export const reqDetails = (params)=>axios({url:"/details",method:'post',data:params})

export const reqDetailsimg = (params)=>axios({url:"/img",method:'post',data:params})

export const reqVerifycode = (params)=>axios({url:'/getVerifycode',method:'post',data:params})

export const register = (params)=>axios({url:'/register',method:'post',data:params})

export const reqsearch = (params)=>axios({url:'/search',method:'post',data:params})

export const login = (params)=>axios({url:'/login',method:'post',data:params})

export const userinfo = (params)=>axios({url:'/userinfo',method:'post',data:params})

export const getUid = ()=>axios({url:'/getUid',method:'post'})

export const getShopcar = (id)=>axios({url:'/getShopcar',method:'post',data:id})

export const updateShopcar = (data)=>axios({url:'/updateShopcar',method:'post',data})

export const uploadInquiry = (id)=>axios({url:'/uploadInquiry',method:'post',data:id})

export const detaInsert = (id)=>axios({url:'/detaInsert',method:'post',data:id})

export const enquiry = (data)=>axios({url:'/enquiry',method:'post',data})

export const gethistory = (data)=>axios({url:'/history',method:'post',data})

export const updatehistory = (data)=>axios({url:'/updateHistory',method:'post',data})

export const getBrands = (data)=>axios({url:'/brands',method:'post',data})

export const index = (data)=>axios({url:'/index',method:'post',data})

export const news = (data)=>axios({url:'/news',method:'post',data})

export const about = (data)=>axios({url:'/about',method:'post',data})

export const newsGet = (data)=>axios({url:'/newsGet',method:'post',data})

export const retrieve = (data)=>axios({url:'/retrieve',method:'post',data})

export const swiper = ()=>axios({url:'/swiper',method:'post'})


// export default{
//     install:Vue=>{
//         Vue.api = api,
//         Vue.prototype.$api = api
//     }
// }


